<template>
    <div>
        <v-card
            class="mt-2"
            v-if="
                status_print_issue === false && status_print_transfer === false
            "
        >
            <v-card-title>
                <v-row>
                    <v-col cols="12" class="text-right">
                        <v-btn
                            rounded
                            small
                            color="success"
                            v-if="form === 'TRANSFER' || form === 'TRANSFER CE'"
                            @click="save_tranfer()"
                            ><v-icon small>mdi-content-save</v-icon>Save</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>

            <div ref="issue" v-if="form === 'ISSUE'">
                <v-row class="mar-t-40">
                    <v-col cols="12" class="ml-2">
                        <b>Part Recommended</b>
                        <v-btn
                            small
                            rounded
                            color="green"
                            class="white--text ml-5"
                            @click="export_data_issue(active_tab)"
                        >
                            Export {{ active_tab }}
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- tab -->
                <v-tabs
                    v-model="tab"
                    background-color="blue accent-2"
                    color="lime accent-2"
                    class="elevation-2"
                    dark
                    :grow="true"
                >
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab
                        v-for="i in tabs_name.length"
                        :key="i"
                        :href="`#tab-${i}`"
                        @click="change_tab(tabs_name[i - 1])"
                    >
                        <v-icon
                            class="mr-1"
                            v-if="tabs_name[i - 1] === active_tab"
                            >mdi-checkbox-marked-circle</v-icon
                        >
                        {{ tabs_name[i - 1] }}
                    </v-tab>

                    <v-tab-item
                        v-for="i in tabs_name.length"
                        :key="i"
                        :value="'tab-' + i"
                    >
                        <v-row>
                            <v-col cols="10" sm="6" md="4" class="mar-t-20">
                                <v-text-field
                                    @keyup="check_search_case()"
                                    v-model="form_search"
                                    class="pt-5"
                                    label="Search Case"
                                    prepend-inner-icon="mdi-magnify"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <div id="main_issue" class="mar-t-20">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        Case
                                                    </th>
                                                    <th class="text-center">
                                                        Part Description
                                                    </th>

                                                    <th
                                                        class="text-center"
                                                        v-if="
                                                            active_tab !=
                                                                'Hub - Vendor'
                                                        "
                                                    >
                                                        {{
                                                            team_name == "ASRC"
                                                                ? "Claim"
                                                                : "Issue"
                                                        }}
                                                    </th>
                                                    <th
                                                        v-if="
                                                            team_name == 'ASRC'
                                                        "
                                                    >
                                                        Cancel
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_issue"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        {{ index + 1 }}.
                                                    </td>
                                                    <td class="pt-2 pb-2">
                                                        <v-row>
                                                            <v-col cols="10">
                                                                <v-chip
                                                                    dense
                                                                    x-small
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        row.project_name
                                                                    }}
                                                                </v-chip>
                                                                <v-chip
                                                                    dense
                                                                    x-small
                                                                    class="ml-2 font-weight-bold"
                                                                    color="orange darken-3"
                                                                    text-color="white"
                                                                >
                                                                    {{
                                                                        row.branch_name
                                                                    }}
                                                                </v-chip>
                                                                <br />
                                                                <span
                                                                    class="font-weight-medium"
                                                                >
                                                                    {{
                                                                        row.case_id
                                                                    }}
                                                                </span>
                                                                <span
                                                                    class="font-weight-light"
                                                                >
                                                                    {{
                                                                        row.case_refer
                                                                    }}</span
                                                                >
                                                                <br />
                                                                <span
                                                                    class="font-weight-light caption"
                                                                    >{{
                                                                        row.site_name
                                                                    }}</span
                                                                >
                                                            </v-col>
                                                            <v-col
                                                                cols="2"
                                                                align-self="center"
                                                            >
                                                                <ViewMore
                                                                    class="fix-flex-end-row"
                                                                    :maincaseid="
                                                                        row.maincase_id
                                                                    "
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                    </td>
                                                    <td>
                                                        <v-simple-table>
                                                            <tbody>
                                                                <tr
                                                                    v-for="(r,
                                                                    i) in row.parts"
                                                                    :key="i"
                                                                >
                                                                    <td
                                                                        width="70%"
                                                                    >
                                                                        <v-btn
                                                                            :disabled="
                                                                                active_tab ==
                                                                                    'Hub - Vendor'
                                                                            "
                                                                            rounded
                                                                            x-small
                                                                            @click="
                                                                                send_back_order(
                                                                                    r.part_issue_id
                                                                                )
                                                                            "
                                                                            >{{
                                                                                r.part_name
                                                                            }}</v-btn
                                                                        >
                                                                        {{
                                                                            r.part_description
                                                                        }}
                                                                        <v-chip
                                                                            x-small
                                                                        >
                                                                            {{
                                                                                r.remark
                                                                            }}
                                                                        </v-chip>
                                                                    </td>
                                                                    <td
                                                                        width="30%"
                                                                        class="text-center"
                                                                    >
                                                                        <v-chip
                                                                            dense
                                                                            x-small
                                                                            color="blue darken-3"
                                                                            text-color="white"
                                                                            class="font-weight-bold"
                                                                        >
                                                                            HQ :
                                                                            {{
                                                                                r.hq_qty
                                                                            }}
                                                                        </v-chip>
                                                                        <v-chip
                                                                            dense
                                                                            x-small
                                                                            color="orange darken-3"
                                                                            text-color="white"
                                                                            class="font-weight-bold"
                                                                        >
                                                                            HUB
                                                                            :
                                                                            {{
                                                                                r.hub_qty
                                                                            }}
                                                                        </v-chip>
                                                                        <v-chip
                                                                            dense
                                                                            x-small
                                                                            class="font-weight-bold"
                                                                        >
                                                                            RESERVE
                                                                            :
                                                                            {{
                                                                                r.hub_reserve
                                                                            }}
                                                                        </v-chip>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-simple-table>
                                                    </td>

                                                    <td
                                                        class="text-center"
                                                        v-if="
                                                            active_tab !=
                                                                'Hub - Vendor'
                                                        "
                                                    >
                                                        <v-btn
                                                            v-if="
                                                                active_tab !=
                                                                    'Back Order' ||
                                                                    row.main_status_name ==
                                                                        'Wait Part'
                                                            "
                                                            href="#scroll"
                                                            color="primary"
                                                            dark
                                                            class="mb-2"
                                                            fab
                                                            x-small
                                                            @click="
                                                                issue_add(
                                                                    row.maincase_id,
                                                                    row.subcase,
                                                                    row.project_name,
                                                                    row.case_id,
                                                                    row.site_name
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-plus</v-icon
                                                            >
                                                        </v-btn>
                                                        <span v-else>{{
                                                            row.main_status_name
                                                        }}</span>
                                                    </td>
                                                    <td
                                                        v-if="
                                                            team_name == 'ASRC'
                                                        "
                                                    >
                                                        <v-btn
                                                            fab
                                                            x-small
                                                            color="red accent-2 mb-2"
                                                            @click="
                                                                fucnc_cancel()
                                                            "
                                                        >
                                                            <v-icon
                                                                class="white--text"
                                                                >mdi-close</v-icon
                                                            >
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <br />
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="issue_form_case === true"
                                class="pa-5 mar-t-30"
                            >
                                <v-col cols="5" sm="4" md="3">
                                    <v-dialog
                                        ref="dialog"
                                        v-model="modal"
                                        :return-value.sync="datas.date"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="datas.date"
                                                label="Date"
                                                prepend-icon=""
                                                readonly
                                                v-on="on"
                                                :rules="dateR"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="date"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="modal = false"
                                                >Cancel</v-btn
                                            >
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.dialog.save(date)"
                                                >OK</v-btn
                                            >
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="2" class="text-right">
                                    <v-btn
                                        :disabled="rows.length == 0"
                                        rounded
                                        small
                                        color="success"
                                        v-if="form === 'ISSUE'"
                                        @click="save_issue()"
                                        ><v-icon small>mdi-content-save</v-icon
                                        >Save</v-btn
                                    >
                                </v-col>
                            </v-row>
                            <v-row
                                v-if="issue_form_case === true"
                                class="mar-t-10 pa-5 mar-50"
                            >
                                <v-col cols="12" sm="6" md="4"
                                    ><b>Project : </b>{{ show.project }}</v-col
                                >
                                <v-col cols="12" sm="6" md="4"
                                    ><b>Case : </b>{{ show.case }}</v-col
                                >
                                <v-col cols="12" sm="6" md="4"
                                    ><b>Site Name : </b
                                    >{{ show.sitename }}</v-col
                                >
                            </v-row>

                            <v-row v-if="issue_form_case === true">
                                <v-col cols="12" class="mar-t-10">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        Single Part
                                                    </th>
                                                    <th class="text-center">
                                                        Status Part
                                                    </th>
                                                    <th class="text-center">
                                                        Serial Number
                                                    </th>
                                                    <th class="text-center">
                                                        Part Desc.
                                                    </th>
                                                    <th class="text-center">
                                                        Location
                                                    </th>
                                                    <th class="text-center">
                                                        Action
                                                    </th>
                                                    <th class="text-center">
                                                        Remark
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="chk_sg === true">
                                                    <td
                                                        colspan="8"
                                                        class="text-center"
                                                    >
                                                        <span
                                                            class="text-color-red"
                                                            >{{
                                                                text_show
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(n, index) in rows"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ n[0].singlepart }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ n[0].status }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ n[0].serial }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{
                                                            n[0].part_name +
                                                                " - " +
                                                                n[0]
                                                                    .part_description
                                                        }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ n[0].location }}
                                                    </td>
                                                    <td class="text-center">
                                                        <v-btn
                                                            class="mx-2"
                                                            fab
                                                            dark
                                                            x-small
                                                            color="red"
                                                            @click="
                                                                remove(index)
                                                            "
                                                        >
                                                            <v-icon dark x-small
                                                                >mdi-minus</v-icon
                                                            >
                                                        </v-btn>
                                                    </td>
                                                    <td>
                                                        {{ n[0].remark }}
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(n,
                                                    index2) in data_sg_issue"
                                                    :key="'xx' + index2"
                                                >
                                                    <td>{{ index2 + 1 }}.</td>
                                                    <td>
                                                        <v-text-field
                                                            label="Single Part"
                                                            v-on:keyup.enter="
                                                                get_data(
                                                                    index2,
                                                                    n.part_issue_id
                                                                )
                                                            "
                                                            v-model="
                                                                is_sgp
                                                                    .singlepart[
                                                                    index2
                                                                ]
                                                            "
                                                        ></v-text-field>
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                        {{
                                                            n.part_name +
                                                                " - " +
                                                                n.part_description
                                                        }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ n.hq_location }}
                                                    </td>
                                                    <td>
                                                        <v-checkbox
                                                            v-if="
                                                                team_name ==
                                                                    'INVENTORY'
                                                            "
                                                            @change="
                                                                push_data(
                                                                    index2,
                                                                    n
                                                                )
                                                            "
                                                            label="Use spare part at hub ?"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td>{{ n.remark }}</td>
                                                </tr>

                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <v-text-field
                                                            label="Single Part"
                                                            v-on:keyup.enter="
                                                                get_data()
                                                            "
                                                            v-model="
                                                                sgp.singlepart
                                                            "
                                                        ></v-text-field>
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <br />
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </div>
                    </v-tab-item>
                </v-tabs>
            </div>

            <div ref="tranfer" v-if="form === 'TRANSFER'">
                <v-row class="pa-5">
                    <v-col cols="12" sm="6" md="4">
                        <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="datas.date"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="datas.date"
                                    label="Date"
                                    prepend-icon=""
                                    readonly
                                    v-on="on"
                                    :rules="dateR"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="datas.date" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="modal = false"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog.save(datas.date)"
                                    >OK</v-btn
                                >
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="6" md="4"
                        ><v-select
                            v-model="datas.transfer_type"
                            label="Type"
                            :items="types"
                            hide-details
                            required
                            :rules="typeR"
                            @change="select_type()"
                        ></v-select
                    ></v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-if="datas.transfer_type === 'Branch'"
                        ><v-select
                            label="Branch"
                            hide-details
                            required
                            :rules="BranchR"
                            :items="type_data"
                            v-model="datas.branch"
                            item-text="branch_name"
                            item-value="branch_id"
                        ></v-select
                    ></v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-if="datas.transfer_type === 'Supplier'"
                        ><v-select
                            label="Supplier"
                            hide-details
                            required
                            v-model="datas.supplier"
                            :rules="SupplierR"
                            :items="type_data"
                            item-text="supplier_name"
                            item-value="supplier_id"
                        ></v-select
                    ></v-col>
                </v-row>
                <v-row class="mar-t-10"> </v-row>

                <v-row class="mar-t-20">
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">#</th>
                                        <th class="text-center">Single Part</th>
                                        <th class="text-center">Status Part</th>
                                        <th class="text-center">
                                            Serial Number
                                        </th>
                                        <th class="text-center">Part No</th>
                                        <th class="text-center">Part Desc.</th>
                                        <th class="text-center">Location</th>
                                        <th class="text-center">Remark</th>
                                        <th class="text-center">Del.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="chk_sg === true">
                                        <td colspan="7" class="text-center">
                                            <span class="text-color-red">{{
                                                text_show
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr v-for="(n, index) in rows" :key="index">
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].singlepart }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].status }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].serial }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].part_name }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].part_description }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].location }}
                                        </td>
                                        <td class="text-center">
                                            <v-text-field
                                                v-model="n[0].remark"
                                                label="Remark"
                                            ></v-text-field>
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                class="mx-2"
                                                fab
                                                dark
                                                x-small
                                                color="red"
                                                @click="remove(index)"
                                            >
                                                <v-icon dark x-small
                                                    >mdi-minus</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <v-text-field
                                                label="Single Part"
                                                v-on:keyup.enter="get_data()"
                                                v-model="sgp.singlepart"
                                            ></v-text-field>
                                        </td>
                                        <td colspan="6"></td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>

            <div ref="tranferce" v-if="form === 'TRANSFER CE'">
                <v-row class="pa-5">
                    <v-col cols="12" sm="6" md="4">
                        <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="datas.date"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="datas.date"
                                    label="Date"
                                    prepend-icon=""
                                    readonly
                                    v-on="on"
                                    :rules="dateR"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="datas.date" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="modal = false"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog.save(datas.date)"
                                    >OK</v-btn
                                >
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col
                        v-if="team_name == 'INVENTORY'"
                        cols="12"
                        sm="6"
                        md="4"
                        ><v-select
                            label="Zone"
                            hide-details
                            :items="data_zone"
                            v-model="zone"
                            item-text="zone_name"
                            item-value="zone_id"
                            @change="get_engineer()"
                        ></v-select
                    ></v-col>
                    <v-col cols="12" sm="6" md="4"
                        ><v-select
                            label="Engineer"
                            hide-details
                            required
                            :rules="EngineerR"
                            :items="data_engineer"
                            v-model="datas.engineer"
                            item-text="emp_name_en"
                            item-value="emp_id"
                        ></v-select
                    ></v-col>
                </v-row>
                <v-row class="mar-t-10"> </v-row>

                <v-row class="mar-t-20">
                    <v-col cols="12">
                        <v-simple-table class="table-inv">
                            <template v-slot:default>
                                <thead>
                                    <tr class="col-tr-1">
                                        <th class="text-center">#</th>
                                        <th class="text-center">Single Part</th>
                                        <th class="text-center">Status Part</th>
                                        <th class="text-center">
                                            Serial Number
                                        </th>
                                        <th class="text-center">Part No</th>
                                        <th class="text-center">Part Desc.</th>
                                        <th class="text-center">Location</th>
                                        <th class="text-center">Del.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="chk_sg === true">
                                        <td colspan="7" class="text-center">
                                            <span class="text-color-red">{{
                                                text_show
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr v-for="(n, index) in rows" :key="index">
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].singlepart }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].status }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].serial }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].part_name }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].part_description }}
                                        </td>
                                        <td class="text-center">
                                            {{ n[0].location }}
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                class="mx-2"
                                                fab
                                                dark
                                                x-small
                                                color="red"
                                                @click="remove(index)"
                                            >
                                                <v-icon dark x-small
                                                    >mdi-minus</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <v-text-field
                                                label="Single Part"
                                                v-on:keyup.enter="get_data()"
                                                v-model="sgp.singlepart"
                                            ></v-text-field>
                                        </td>
                                        <td colspan="6"></td>
                                    </tr>
                                    <br />
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <v-row v-if="status_print_transfer === true">
            <v-col cols="12" class="text-right">
                <v-btn rounded small @click="print_transfer()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>

        <div id="printDivTransfer" v-if="status_print_transfer === true">
            <div style="margin: 30px !important">
                <v-row class="mt-4">
                    <v-col cols="3">
                        <img
                            src="../../../assets/bardode/acacia2.png"
                            style="width: 60% !important"
                        />
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <b>เอกสารการ transfer อะไหล่</b>
                    </v-col>
                    <v-col cols="3">
                        <b>วันที่ : {{ data_print_transfer.created_date }}</b>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="2" class="text-right"><b>ส่งจาก :</b></v-col>
                    <v-col cols="4">{{
                        data_print_transfer.from_branch
                    }}</v-col>
                    <v-col cols="2" style="font-size:20px;" class="text-right"
                        ><b>ส่งถึง :</b></v-col
                    >
                    <v-col cols="4" style="font-size:20px;">{{
                        data_print_transfer.branch_name
                    }}</v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
                    <v-col cols="4">{{ data_print_transfer.from_addr }}</v-col>
                    <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
                    <v-col cols="4">{{
                        data_print_transfer.branch_addr_en
                    }}</v-col>
                </v-row>

                <v-row class="mt-4">
                    <v-col cols="12">
                        <table border="1" width="100%">
                            <thead>
                                <tr
                                    class="text-center"
                                    style="background-color: rgb(221, 221, 221)"
                                >
                                    <th>No</th>
                                    <th>Part No</th>
                                    <th>Description</th>
                                    <th>Single Part</th>
                                    <th>SN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(n,
                                    index) in data_print_transfer.transfer_detail"
                                    :key="index"
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td class="text-center">
                                        {{ n.part_name }}
                                    </td>
                                    <td class="text-center">
                                        {{ n.part_description }}
                                    </td>
                                    <td class="text-center">
                                        {{ n.singlepart }}
                                    </td>
                                    <td class="text-center">{{ n.serial }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="6" class="text-right">
                        <b>ผู้ส่ง (Inventory)</b>
                        ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>ผู้รับ (Engineer)</b>
                        ___________________________________
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>วันที่ส่ง</b> ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>วันที่รับ</b> ___________________________________
                    </v-col>
                </v-row>
            </div>
        </div>

        <v-row v-if="status_print_issue === true">
            <v-col cols="12" class="text-right">
                <v-btn
                    rounded
                    small
                    @click="printReturm()"
                    color="blue-grey lighten-3"
                >
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print Return</v-btn
                >
                <v-btn rounded small @click="print_issue()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print Issue</v-btn
                >
            </v-col>
        </v-row>

        <div id="printDivRetuen" v-if="status_print_issue === true">
            <v-row
                v-for="(r, i) in data_print_issue.parts_print"
                :key="i"
                class="ml-2"
            >
                <v-col cols="5" style="border-style: solid">
                    <v-row style="margin-bottom: 8px">
                        <v-col cols="4"
                            ><img
                                src="../../../assets/bardode/acacia.jpg"
                                class="img-1"
                                style="margin-top: 5px"
                        /></v-col>
                        <v-col cols="3">
                            <barcode
                                v-bind:value="r.singlepart"
                                width="1"
                                height="50"
                                font-size="12"
                            >
                            </barcode>
                        </v-col>
                        <v-col cols="5">
                            <qr-code
                                :text="r.singlepart"
                                size="70"
                                style="float: right; margin-top: 5px"
                            ></qr-code>
                        </v-col>
                        <v-col class="mar-t-20" cols="12"
                            ><b>Part Des.</b> {{ r.part_description }}</v-col
                        >
                        <v-col class="mar-t-20" cols="12"
                            ><b>Project :</b>
                            {{ data_print_issue.project_name }}</v-col
                        >
                        <v-col class="mar-t-20" cols="12"
                            ><b>CaseID :</b>
                            {{ data_print_issue.case_id }}</v-col
                        >
                        <v-col class="mar-t-20" cols="4"
                            ><b>GOOD</b>
                            <input type="checkbox" />
                        </v-col>
                        <v-col class="mar-t-20" cols="4"
                            ><b>BAD</b> <input type="checkbox"
                        /></v-col>

                        <v-col class="mar-t-20" cols="4"
                            ><b>DOA</b> <input type="checkbox"
                        /></v-col>
                        <v-col class="mar-t-20" cols="12"
                            >remark...........................................................</v-col
                        >
                    </v-row>
                </v-col>
            </v-row>
        </div>

        <div id="printDiv" v-if="status_print_issue === true">
            <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
            <div style="margin: 30px !important">
                <v-row class="mt-4">
                    <v-col cols="3">
                        <img
                            src="../../../assets/bardode/acacia2.png"
                            style="width: 60% !important"
                        />
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <b>เอกสารใบเบิก Part</b>
                    </v-col>
                    <v-col cols="3">
                        <b>วันที่ : {{ data_print_issue.issue_date }}</b>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="2" class="text-right"><b>ส่งจาก :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.from_branch }}</v-col>
                    <v-col cols="2" style="font-size:20px;" class="text-right"
                        ><b>ส่งถึง :</b></v-col
                    >
                    <v-col cols="4" style="font-size:20px;">{{
                        data_print_issue.branch_name
                    }}</v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.from_addr }}</v-col>
                    <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
                    <v-col cols="4">{{
                        data_print_issue.branch_addr_en
                    }}</v-col>
                </v-row>

                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>Project :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.project_name }}</v-col>
                    <v-col cols="2" class="text-right"
                        ><b>Refer Case :</b></v-col
                    >
                    <v-col cols="4">{{ data_print_issue.case_refer }}</v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>Case No :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.case_id }}</v-col>
                    <v-col cols="2" class="text-right"
                        ><b>Site Address :</b></v-col
                    >
                    <v-col cols="4">{{ data_print_issue.site_name }}</v-col>
                </v-row>

                <v-row class="mt-4">
                    <v-col cols="12">
                        <table border="1" width="100%">
                            <thead>
                                <tr
                                    class="text-center"
                                    style="background-color: rgb(221, 221, 221)"
                                >
                                    <th>No</th>
                                    <th>Part No</th>
                                    <th>Description</th>
                                    <th>Single Part</th>
                                    <th>SN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(n,
                                    index) in data_print_issue.parts_print"
                                    :key="index"
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td class="text-center">
                                        {{ n.part_name }}
                                    </td>
                                    <td class="text-center">
                                        {{ n.part_description }}
                                    </td>
                                    <td class="text-center">
                                        {{ n.singlepart }}
                                    </td>
                                    <td class="text-center">{{ n.serial }}</td>
                                </tr>
                                <br />
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="6" class="text-right">
                        <b>ผู้ส่ง (Inventory)</b>
                        ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>ผู้รับ (Engineer)</b>
                        ___________________________________
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>วันที่ส่ง</b> ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>วันที่รับ</b> ___________________________________
                    </v-col>
                </v-row>
                <!-- <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>ผู้ส่งคืน (Engineer)</b>
                        ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>ผู้รับของคืน (Inventory)</b>
                        ___________________________________
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>วันที่ส่งคืน</b> ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>วันที่รับของคืน</b>
                        ___________________________________
                    </v-col>
                </v-row> -->
                <v-row class="mt-4">
                    <v-col cols="12"><hr /></v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="3">
                        <img
                            src="../../../assets/bardode/acacia2.png"
                            style="width: 60% !important"
                        />
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <b>เอกสารใบเบิก Part</b>
                    </v-col>
                    <v-col cols="3">
                        <b>วันที่ : {{ data_print_issue.issue_date }}</b>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="2" class="text-right"><b>ส่งจาก :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.from_branch }}</v-col>
                    <v-col cols="2" style="font-size:20px;" class="text-right"
                        ><b>ส่งถึง :</b></v-col
                    >
                    <v-col cols="4" style="font-size:20px;">{{
                        data_print_issue.branch_name
                    }}</v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.from_addr }}</v-col>
                    <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
                    <v-col cols="4">{{
                        data_print_issue.branch_addr_en
                    }}</v-col>
                </v-row>

                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>Project :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.project_name }}</v-col>
                    <v-col cols="2" class="text-right"
                        ><b>Refer Case :</b></v-col
                    >
                    <v-col cols="4">{{ data_print_issue.case_refer }}</v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="2" class="text-right"><b>Case No :</b></v-col>
                    <v-col cols="4">{{ data_print_issue.case_id }}</v-col>
                    <v-col cols="2" class="text-right"
                        ><b>Site Address :</b></v-col
                    >
                    <v-col cols="4">{{ data_print_issue.site_name }}</v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="12">
                        <table border="1" width="100%">
                            <thead>
                                <tr
                                    class="text-center"
                                    style="background-color: rgb(221, 221, 221)"
                                >
                                    <th>No</th>
                                    <th>Part No</th>
                                    <th>Description</th>
                                    <th>Single Part</th>
                                    <th>SN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(n,
                                    index) in data_print_issue.parts_print"
                                    :key="index"
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td class="text-center">
                                        {{ n.part_name }}
                                    </td>
                                    <td class="text-center">
                                        {{ n.part_description }}
                                    </td>
                                    <td class="text-center">
                                        {{ n.singlepart }}
                                    </td>
                                    <td class="text-center">{{ n.serial }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="6" class="text-right">
                        <b>ผู้ส่ง (Inventory)</b>
                        ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>ผู้รับ (Engineer)</b>
                        ___________________________________
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>วันที่ส่ง</b> ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>วันที่รับ</b> ___________________________________
                    </v-col>
                </v-row>
                <!-- <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>ผู้ส่งคืน (Engineer)</b>
                        ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>ผู้รับของคืน (Inventory)</b>
                        ___________________________________
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="6" class="text-right">
                        <b>วันที่ส่งคืน</b> ___________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>วันที่รับของคืน</b>
                        ___________________________________
                    </v-col>
                </v-row> -->
            </div>
        </div>
        <div class="text-center">
            <v-overlay :value="overlay">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
        <div id="scroll" ref="scroll"></div>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import VueHtmlToPaper from "vue-html-to-paper"
import { mapState, mapMutations } from "vuex"
import VueBarcode from "vue-barcode"
import Qrcode from "v-qrcode/src/index"
import ViewMore from "./ViewMore"

const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
}

export default {
    components: {
        barcode: VueBarcode,
        Qrcode,
        ViewMore,
    },
    created() {
        this.check_search_case = _.debounce(this.check_search_case, 1500)
    },
    props: ["form"],
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        if (this.form == "ISSUE") {
            this.get_data_issue()
            // this.get_back_order()
        }

        if (this.form == "TRANSFER CE") {
            this.get_engineer()
            this.datas.transfer_type = "CE"
        }

        if (
            this.team_name == "SVC" ||
            this.team_name == "ONSITE" ||
            this.team_name == "SUPPORTUC"
        ) {
            this.tabs_name = ["UC ONSITE", "SRFR", "KBank Toner"]
        }

        if (this.team_name == "ASRC") {
            this.tabs_name = ["BKK", "UC"]
        }
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async issue_add(
            maincase_id,
            subcase,
            project_name,
            case_id,
            site_name
        ) {
            // this.overlay = true
            this.dialog_loading = true
            this.show.project = project_name
            this.show.case = case_id
            this.show.sitename = site_name
            let url = `${process.env.VUE_APP_ROOT_API}/api/listrecpart/`
            await axios
                .get(url + maincase_id + "/" + subcase)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_sg_issue = response.data
                    this.issue_form_case = true
                    this.rows = []
                    this.datas.maincase_id = maincase_id
                    this.datas.subcase = subcase
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async select_type() {
            let url = `${process.env.VUE_APP_ROOT_API}/api/transfertype`
            let { data } = await axios.post(url, this.datas)
            this.type_data = data
        },
        async get_data_issue(v) {
            this.dialog_loading = true
            let search = ""
            search =
                v != undefined
                    ? v
                    : this.team_name === "SVC"
                    ? "UC ONSITE"
                    : "BKK"
            this.active_tab = search

            let url =
                `${process.env.VUE_APP_ROOT_API}/api/casependingpart/` + search
            await axios
                .get(url, this.tk)
                .then((response) => {
                    console.log(response.data)
                    this.data_issue = response.data
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
            // console.log(data)
        },
        async export_data_issue(v) {
            this.dialog_loading = true
            let search = ""
            search =
                v != undefined
                    ? v
                    : this.team_name === "SVC"
                    ? "UC ONSITE"
                    : "BKK"
            this.active_tab = search

            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/casependingpart-export/${search}`,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.dialog_loading = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute(
                    "download",
                    "part_recommended_report.xlsx"
                )
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async get_engineer() {
            let url = `${process.env.VUE_APP_ROOT_API}/api/svc-ce/${this.zone}`
            let { data } = await axios.get(url, this.tk)
            this.data_engineer = data[0].engineer
        },
        async get_data(indexs, part_issue_id) {
            let url = `${process.env.VUE_APP_ROOT_API}/api/checksinglepart`
            this.chk_sg = false
            if (this.form === "ISSUE") {
                if (indexs === undefined) {
                    let { data } = await axios.post(url, this.sgp, this.tk)
                    // console.log(data, "-data")
                    if (data.length === 0) {
                        this.text_show = "ไม่พบ Single Part ที่ระบุในระบบ"
                        this.chk_sg = true
                    } else {
                        if (this.rows.length > 0) {
                            const found1 = this.rows.some(
                                (el) => el[0].singlepart === data[0].singlepart
                            )
                            if (found1 === false) {
                                this.rows.push(data)
                                this.sgp.singlepart = ""
                            } else if (found1 === true) {
                                this.text_show =
                                    "ท่านทำรายการซ้ำ กรุณาทำรายการใหม่อีกครั้ง"
                                this.chk_sg = true
                            }
                        } else {
                            this.rows.push(data)
                            this.sgp.singlepart = ""
                        }
                    }
                } else {
                    if (part_issue_id === "") {
                        this.text_show = "ไม่พบ Single Part ที่ระบุในระบบ"
                        this.chk_sg = true
                    } else {
                        let check_data = {
                            singlepart: this.is_sgp.singlepart[indexs],
                        }
                        let { data } = await axios.post(
                            url,
                            check_data,
                            this.tk
                        )

                        if (data.length === 0) {
                            this.text_show = "ไม่พบ Single Part ที่ระบุในระบบ"
                            this.chk_sg = true
                        } else {
                            data[0].part_issue_id = part_issue_id

                            if (this.rows.length > 0) {
                                const found = this.rows.some(
                                    (el) =>
                                        el[0].singlepart === data[0].singlepart
                                )
                                if (found === false) {
                                    // this.data_sg_issue.splice(indexs, 1)
                                    this.data_sg_issue = this.data_sg_issue.filter(
                                        (item) =>
                                            item !== this.data_sg_issue[indexs]
                                    )
                                    this.rows.push(data)
                                } else if (found === true) {
                                    this.text_show =
                                        "ท่านทำรายการซ้ำ กรุณาทำรายการใหม่อีกครั้ง"
                                    this.chk_sg = true
                                }
                            } else {
                                // this.data_sg_issue.splice(indexs, 1)
                                this.data_sg_issue = this.data_sg_issue.filter(
                                    (item) =>
                                        item !== this.data_sg_issue[indexs]
                                )

                                this.rows.push(data)
                            }

                            this.is_sgp.singlepart[indexs] = ""
                        }
                    }
                }
            } else {
                let { data } = await axios.post(url, this.sgp, this.tk)
                if (data.length === 0) {
                    this.text_show = "ไม่พบ Single Part ที่ระบุในระบบ"
                    this.chk_sg = true
                } else {
                    const found = this.rows.some(
                        (el) => el[0].singlepart === data[0].singlepart
                    )
                    if (found === false) {
                        this.rows.push(data)
                        this.sgp.singlepart = ""
                    } else if (found === true) {
                        this.text_show =
                            "ท่านทำรายการซ้ำ กรุณาทำรายการใหม่อีกครั้ง"
                        this.chk_sg = true
                    }
                }
            }
        },
        push_data(index, n) {
            this.chk_sg = false
            let data = [
                {
                    part_issue_id: n.part_issue_id,
                    hub: "true",
                    singlepart: "",
                    status: "",
                    serial: n.serial,
                    part_name: n.part_name,
                    part_description: n.part_description,
                    location: "Use spare parta at hub",
                },
            ]
            this.rows.push(data)
            this.data_sg_issue.splice(index, 1)
        },
        change_tab(change_tab) {
            this.issue_form_case = false
            // this.active_tab = change_tab
            this.get_data_issue(change_tab)
            // this.get_back_order(change_tab)
        },
        remove(indexs) {
            this.rows.splice(indexs, 1)
        },
        async save_tranfer() {
            this.dialog_loading = true
            this.datas.type = this.form
            let url = `${process.env.VUE_APP_ROOT_API}/api/invsaveform`
            await axios
                .post(
                    url,
                    {
                        data: {
                            data1: this.datas,
                            data2: this.rows,
                        },
                    },
                    this.tk
                )
                .then((response) => {
                    this.dialog_loading = false
                    this.mutatesnackbar()
                    this.status_print_transfer = true
                    this.get_data_ptint_transfer(response)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data_ptint_transfer(res) {
            this.dialog_loading = true
            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/transfer_print/` +
                        res.data.transfer_id
                )
                .then((response) => {
                    this.dialog_loading = false
                    this.data_print_transfer = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        print_transfer() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                ],
            }

            this.$htmlToPaper("printDivTransfer", localOptions, () => {})
        },
        async save_issue() {
            this.dialog_loading = true
            this.datas.type = this.form
            let url = `${process.env.VUE_APP_ROOT_API}/api/invsaveform`
            await axios
                .post(
                    url,
                    {
                        data: {
                            data1: this.datas,
                            data2: this.rows,
                        },
                    },
                    this.tk
                )
                .then((response) => {
                    this.dialog_loading = false
                    this.mutatesnackbar()
                    this.status_print_issue = true
                    this.get_data_ptint_issue(response)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data_ptint_issue(res) {
            this.dialog_loading = true
            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/issue_print/` +
                        res.data.maincase_id +
                        "/" +
                        res.data.subcase
                )
                .then((response) => {
                    this.dialog_loading = false
                    this.data_print_issue = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        print_issue() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                ],
            }

            this.$htmlToPaper("printDiv", localOptions, () => {})
        },
        printReturm() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                ],
            }

            this.$htmlToPaper("printDivRetuen", localOptions, () => {})
        },
        send_back_order(part_issue_id) {
            if (this.active_tab !== "Back Order") {
                this.$swal({
                    title: "Are you sure?",
                    text: "Save Part Back order",
                    icon: "warning",

                    buttons: {
                        cancel: true,
                        text: "Save Back order",
                    },
                }).then((conf) => {
                    if (conf) {
                        axios
                            .post(
                                `${process.env.VUE_APP_ROOT_API}/api/save-backorder/` +
                                    part_issue_id,
                                {},
                                this.tk
                            )
                            .then((response) => {
                                this.get_data_issue()
                                // this.get_back_order()
                            })
                            .catch((error) => {
                                console.log(error)
                            })
                    } else {
                        // console.log("-2")
                    }
                })
            }
        },
        async check_search_case() {
            this.dialog_loading = true
            let searchtext = {
                searchtext: this.form_search,
            }
            if (this.form_search != "") {
                await axios
                    .post(
                        `${process.env.VUE_APP_ROOT_API}/api/issue-search-case`,
                        searchtext
                    )
                    .then((response) => {
                        this.dialog_loading = false
                        if (response.data.case_id == undefined) {
                            this.$swal("Search not found", {
                                title: this.form_search,
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        } else {
                            this.form_search = ""
                            this.$swal("Successful Search", {
                                title: this.form_search,
                                icon: "success",
                                button: false,
                                timer: 2000,
                            })

                            let element = this.$refs["scroll"]
                            let top = element.offsetTop
                            window.scrollTo(0, top)

                            this.issue_add(
                                response.data.maincase_id,
                                response.data.subcase,
                                response.data.project_name,
                                response.data.case_id,
                                response.data.site_name
                            )
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        fucnc_cancel() {
            console.log("fucnc_cancel")
        },
    },
    data: () => ({
        dialog_loading: false,
        team_name: localStorage.team_name,
        types: ["Branch", "Supplier"],
        modal: false,
        dateR: [(v) => !!v || "Date is required"],
        typeR: [(v) => !!v || "Transfer Type is required"],
        BranchR: [(v) => !!v || "Branch is required"],
        SupplierR: [(v) => !!v || "Supplier is required"],
        EngineerR: [(v) => !!v || "Engineer is required"],
        issue_form_case: false,
        num_data: 0,
        form_data: [],
        datas: {
            type: "",
            date: new Date().toISOString().substr(0, 10),
            transfer_type: "",
            maincase_id: "",
            engineer: "",
            zone: "",
        },
        sgp: {
            singlepart: "",
        },
        is_sgp: {
            singlepart: [],
        },
        type_data: [],
        chk_sg: false,
        rows: [],
        data_issue: [],
        data_engineer: [],
        show: {
            project: "",
            case: "",
            sitename: "",
        },
        data_sg_issue: [],
        text_show: "",
        status_print_issue: false,
        data_print_issue: [],
        status_print_transfer: false,
        data_print_transfer: [],
        overlay: false,
        data_back_order: [],
        chk_show_part: false,
        date: null,
        tab: false,
        zone: localStorage.team_name,
        active_tab: "BKK",
        tabs_name: ["BKK", "UC ONSITE", "SRFR", "Hub - Vendor", "Back Order"],
        data_zone: ["INVENTORY", "NONHP"],
        form_search: "",
    }),
}
</script>

<style scoped>
.mar-50 {
    margin-top: -50px;
}
html {
    scroll-behavior: smooth;
}
</style>
